import {Component, inject} from "@angular/core";
import {CookieService} from "ngx-cookie-service";
import {SelectionService} from "../../services/selection.service";
import {IncidentIdService} from "../../features/error-report/data-access/incident-id.service";
import {ReportService} from "../../features/error-report/data-access/report.service";
import {UserService} from "../../services/user.service";
import {KnowledgeBaseService} from "../../features/knowledge-database/data-access/knowledge-base.service";

@Component({
  selector: "app-active-workplace",
  templateUrl: "./active-workplace.component.html",
  styleUrls: ["./active-workplace.component.scss"],
})
export class ActiveWorkplaceComponent {
  selectionService = inject(SelectionService);
  incidentIdService = inject(IncidentIdService);
  knowledgeBaseService = inject(KnowledgeBaseService);
  reportService = inject(ReportService);
  userService = inject(UserService);
  cookieService = inject(CookieService);
  productionLine: string = this.cookieService
    .get("productionLine")
    .split("%")[1];
  workplace: string = this.cookieService.get("workplace").split("%")[1];
}
